import Image from "next/image";
import { useState } from "react";
import Link from "next/link";
import Minus from "components/Icons/Minus";
import Plus from "components/Icons/Plus";
import { isProdBuild } from '../../lib/isProdBuild';

const emptyProps = async () => ({ props: {} });

export const getServerSideProps = isProdBuild ? undefined : emptyProps;

export default function HcfNoGap() {
    const [isTCOpen, setIsTCOpen] = useState(true);

    return (
        <div className="w-full">
            {/* Hero Section */}
            <section className="bg-[#E0004D] py-12 px-4 md:px-8">
                <div className="max-w-[1224px] mx-auto text-center">
                    <h1 className="text-white text-3xl md:text-5xl font-bold mb-8">
                        Exclusive no-gap<br />
                        offers for HCF members
                    </h1>

                    <div className="relative w-full h-[480px] mb-8">
                        <Image
                            src="https://cdn.dresden.vision/images/HCF_Landing_Page.png"
                            alt="HCF Members"
                            fill
                            priority
                            className="md:object-cover object-cover"
                        />
                    </div>
                    <Link href="/book-an-optometrist">
                        <button className="bg-white text-black px-8 py-3 rounded-md font-medium hover:bg-gray-100 transition-colors w-[260px] h-[60px]">
                            Book eye test
                        </button>
                    </Link>
                </div>
            </section>

            {/* Info Section */}
            <section className="py-12 px-4 md:px-8">
                <div className="max-w-[1224px] mx-auto">
                    <div className="flex flex-col md:flex-row items-center justify-between mb-8">
                        <div className="mb-6 md:mb-0">
                            <h2 className="text-2xl md:text-4xl font-medium mb-4 text-[#2A2A2A]">
                                Dresden has proudly partnered<br />
                                with HCF&apos;s More for Eyes program
                            </h2>
                            <p className="text-[#616161] text-[16px] max-w-[600px]">
                                Visit any of our stores to enjoy special deals, just for you.
                                Choose from a range of options based on your level of extras cover and remaining annual limits.
                            </p>
                        </div>
                        <Image
                            src="https://cdn.dresden.vision/images/HCF_Logo.png"
                            alt="HCF Logo"
                            width={200}
                            height={132}
                        />
                    </div>

                    {/* Options Table */}
                    <div className="overflow-x-auto">
                        <table className="w-full border-collapse">
                            <thead>
                                <tr className="bg-[#E0004D] text-white h-[85px]">
                                    <th className="p-4 text-left border border-white">If your<br />balance is...</th>
                                    <th className="p-4 text-left border border-white bg-[#2A2A2A] font-semibold">Option <br />1</th>
                                    <th className="p-4 text-left border border-white bg-[#2A2A2A] font-semibold">Option <br />2</th>
                                    <th className="p-4 text-left border border-white bg-[#2A2A2A] font-semibold">Option <br />3</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="p-4 bg-[#E0004D] text-white border border-white">$100+</td>
                                    <td className="p-4 border border-white text-[#616161]">2 pairs of<br />reading or distance</td>
                                    <td className="p-4 border border-white text-[#616161]">1 pair of custom grind<br />reading or distance</td>
                                    <td className="p-4 border border-white text-[#616161]">1 pair of ultra thin<br />reading or distance</td>
                                </tr>
                                <tr>
                                    <td className="p-4 bg-[#E0004D] text-white border border-white">$200+</td>
                                    <td className="p-4 border border-white text-[#616161]">1 pair of<br />standard multifocals</td>
                                    <td className="p-4 border border-white text-[#616161]">3 pairs of<br />reading or distance</td>
                                    <td className="p-4 border border-white text-[#616161]">1 pair of<br />polarised sunglasses</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <Link href="/stores">
                        <button className="mt-8 bg-black text-white px-8 py-3 rounded-md font-medium hover:bg-gray-800 transition-colors w-[260px] h-[60px]">
                            Find a store
                        </button>
                    </Link>

                    {/* T&Cs Section */}
                    <div className="mt-12">
                        <div className="border rounded-lg border-[#CACACA]">
                            <button
                                onClick={() => setIsTCOpen(!isTCOpen)}
                                className="w-full p-5 flex justify-between items-center font-medium"
                            >
                                <span>T&C&apos;s:</span>
                                <span className="text-xl">{isTCOpen ? <Minus fill="#000" /> : <Plus fill="#000" />}</span>
                            </button>
                            {isTCOpen && (
                                <div className="p-4 text-sm text-gray-600 space-y-2 px-[30px]">
                                    <ul className="list-disc pl-4 space-y-2 text-[#616161]">
                                        <li>Offers applies to new orders only, not applicable to existing orders.</li>
                                        <li>Offers can&apos;t be used in conjunction with any other campaigns, promotions or discounts.</li>
                                        <li>Offers are only available per person and can&apos;t be split between multiple people.</li>
                                        <li>Offers are not available on contact lenses, accessories, non-prescription glasses or optometry services.</li>
                                        <li>Single vision offers include 1.5 and 1.6 index stock lenses only, single vision grind lenses are not included.</li>
                                        <li>Two pairs single vision glasses: no gap includes 2 x pairs of standard single vision glasses with no gap, both pairs must be for same person. Offer includes standard 1.5 index lenses or 1.6 index standard lenses based on Dresden&apos;s discretion. Other lenses available at an extra cost.</li>
                                        <li>Two pairs single vision prescription sunglasses: no gap includes 2 x pairs of standard single vision glasses with no gap, both pairs must be for same person. Offer includes standard 1.5 index lenses or 1.6 index standard lenses based on Dresden&apos;s discretion. Other lenses available at an extra cost.</li>
                                        <li>One pair multifocal glasses, no gap: one pair of multifocal glasses with no gap, available in 1.5 index or 1.6 index standard lenses based on Dresden&apos;s discretion. Other lenses available at an extra cost.</li>
                                        <li>One pair multifocal sunglasses, no gap: one pair of multifocal sunglasses with no gap, available in 1.5 index standard only. Other lenses available at an extra cost.</li>
                                        <li>Claiming optical benefits from HCF is subject to your chosen level of optical extras cover, relevant waiting periods being served, and sufficient annual limits remaining.</li>
                                        <li>Benefits only payable on prescription glasses.</li>
                                        <li>HCF More For Eyes benefits rules apply. Contact your HCF member account to determine your remaining available optical extras balance.</li>
                                        <li>Changes and/or up-grades to prescription lenses including customising, thinning, coating, tinting or other optical lens styles not included unless specified.</li>
                                        <li>Visit Dresden in-store with your valid HCF membership card to redeem offers.</li>
                                        <li>Offer available to members of HCF More For Eyes underwritten by HCF.</li>
                                        <li>Offers are not redeemable or transferrable for cash.</li>
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
